<script>

export default {
    methods: {
        goBack() {
          this.$router.push({ path: '/dashboard' });
        },
    },
};
</script>

<template>
    <v-container class="fill-height">
        <v-row class="pt-5 mt-5">
        <v-col class="pt-5 mt-5">
            <v-img src="@/styles/error/media_error.png" style="width: 500px; margin: 0 auto;"></v-img>
        </v-col>
    </v-row>

    <v-row>
        <v-col class="d-flex justify-center text-center">
            <h3>미디어서버가<br>등록되지 않았습니다.</h3>
        </v-col>
    </v-row>

    <v-row>
        <v-col class="d-flex justify-center text-center">
            <!-- 관리자에게 문의하시길 바랍니다. -->
            Please contact your administrator for permission.
        </v-col>
    </v-row>

    <v-row>
        <v-col class="d-flex justify-center">
            <v-btn
            rounded
            large
            x-large
            dark
            elevation="0"
            @click="goBack">
            뒤로 가기
            </v-btn>
        </v-col>
    </v-row>
    </v-container>
</template>